/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomerValidationError {
    SAP_CODE_ALREADY_EXISTS = 'SapCodeAlreadyExists',
    VAT_ID_ALREADY_EXISTS = 'VatIdAlreadyExists',
    TAX_CODE_ALREADY_EXISTS = 'TaxCodeAlreadyExists',
}
